import { call, select, takeEvery } from 'redux-saga/effects';
import qs from 'qs';
import { selectRouteQuery } from 'selectors/general';

export const SET_COLUMN_FOCUS = 'SET_COLUMN_FOCUS';

export const setColumnFocus = focus => ({
  type: SET_COLUMN_FOCUS,
  focus,
});

export function* doSetColumnFocus(dependencies, { focus }) {
  const query = yield select(selectRouteQuery);
  const newQuery = { ...query, focus };
  const newPath = `${window.location.pathname}?${qs.stringify(newQuery)}`;
  yield call(dependencies.navigate, newPath);
}

export function* watchActions(dependencies) {
  yield takeEvery(SET_COLUMN_FOCUS, doSetColumnFocus, dependencies);
}
